module.exports = "<div class=\"ui-widget-header ui-grid\" style=\"font-size: 1.3em\">\n  <div class=\"ui-grid-col-6\" style=\"padding: 10px\">\n    <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i> {{lugar}}\n  </div>\n  <div class=\"ui-grid-col-6\" style=\"padding: 10px;text-align: right\">\n    <i class=\"fa fa-user-circle-o\" aria-hidden=\"true\"></i> {{usuario}}\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/cabecera/cabecera.component.html
// module id = ../../../../../src/app/cabecera/cabecera.component.html
// module chunks = 0